// extracted by mini-css-extract-plugin
module.exports = {"root":"HotelSearchBox_root__1o8dj","closeButton":"HotelSearchBox_closeButton__2AUvl"};